// Generated by `yarn tokens:import` from the Figma "semantic" variables export. Do not edit.

export const semanticModes = {
    'base-ui': '[Base UI]',
    'finavia': '[Finavia]',
    'swedavia': '[Swedavia]',
    'tallinn': '[Tallinn]',
} as const

export const semanticTokens = {
    'action/default': {
        alias: 'action/default',
        type: 'color',
        id: 'VariableID:9192:11980',
        desc: 'Small interactive controls — checkbox fill, radio fill, toggle track, input active border. Aliases Primary/default by default; diverges when brand color fails at small sizes.',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR', 'TEXT_FILL'],
        boundTo: 'primary/default',
    },
    'action/grey-action': {
        alias: 'action/grey-action',
        type: 'color',
        id: 'VariableID:9872:141789',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'TEXT_FILL'],
        boundTo: 'graphics/grey',
    },
    'action/grey-action-hover': {
        alias: 'action/grey-action-hover',
        type: 'color',
        id: 'VariableID:9872:141790',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'TEXT_FILL'],
        boundTo: 'graphics/grey-hover',
    },
    'action/hover': {
        alias: 'action/hover',
        type: 'color',
        id: 'VariableID:9192:11981',
        desc: 'Hover state of action-colored elements. Aliases Primary/hover by default.',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'TEXT_FILL'],
        boundTo: 'primary/hover',
    },
    'action/overlay-action': {
        alias: 'action/overlay-action',
        type: 'color',
        id: 'VariableID:19719:497102',
        modes: {
            'base-ui': {
                boundTo: 'silver/100',
                boundToCollection: '_Primitives graphics',
                value: '#ECEEF5',
            },
            'finavia': {
                boundTo: 'silver/100',
                boundToCollection: '_Primitives graphics',
                value: '#ECEEF5',
            },
            'swedavia': {
                value: '#FFFFFF',
            },
            'tallinn': {
                boundTo: 'silver/100',
                boundToCollection: '_Primitives graphics',
                value: '#ECEEF5',
            },
        },
    },
    'action/overlay-action-hover': {
        alias: 'action/overlay-action-hover',
        type: 'color',
        id: 'VariableID:19719:497103',
        modes: {
            'base-ui': {
                boundTo: 'silver/200',
                boundToCollection: '_Primitives graphics',
                value: '#E2E4EB',
            },
            'finavia': {
                boundTo: 'silver/200',
                boundToCollection: '_Primitives graphics',
                value: '#E2E4EB',
            },
            'swedavia': {
                value: '#FFFFFF',
            },
            'tallinn': {
                boundTo: 'silver/200',
                boundToCollection: '_Primitives graphics',
                value: '#E2E4EB',
            },
        },
    },
    'action/overlay-action-pressed': {
        alias: 'action/overlay-action-pressed',
        type: 'color',
        id: 'VariableID:19719:497104',
        modes: {
            'base-ui': {
                boundTo: 'silver/300',
                boundToCollection: '_Primitives graphics',
                value: '#D5D7DE',
            },
            'finavia': {
                boundTo: 'silver/300',
                boundToCollection: '_Primitives graphics',
                value: '#D5D7DE',
            },
            'swedavia': {
                value: '#FFFFFF',
            },
            'tallinn': {
                boundTo: 'silver/300',
                boundToCollection: '_Primitives graphics',
                value: '#D5D7DE',
            },
        },
    },
    'background/canvas': {
        alias: 'background/canvas',
        type: 'color',
        id: 'VariableID:6201:37711',
        desc: 'Page background, deepest recessed areas, input field fill',
        scopes: ['FRAME_FILL', 'SHAPE_FILL'],
        value: '#111114',
    },
    'background/canvas-hover': {
        alias: 'background/canvas-hover',
        type: 'color',
        id: 'VariableID:9924:54018',
        desc: 'Page background, deepest recessed areas, input field fill',
        scopes: ['FRAME_FILL', 'SHAPE_FILL'],
        value: '#1B1B1E',
    },
    'background/canvas-pressed': {
        alias: 'background/canvas-pressed',
        type: 'color',
        id: 'VariableID:10815:122031',
        scopes: ['FRAME_FILL', 'SHAPE_FILL'],
        value: '#0A0A0D',
    },
    'background/elevation': {
        alias: 'background/elevation',
        type: 'color',
        id: 'VariableID:6201:37714',
        desc: 'Raised element inside a container — card, row, chip, tooltip',
        scopes: ['FRAME_FILL', 'SHAPE_FILL'],
        value: '#262629',
    },
    'background/elevation-hover': {
        alias: 'background/elevation-hover',
        type: 'color',
        id: 'VariableID:9692:59684',
        desc: 'Hover state of elevation background — 8% white on elevation',
        scopes: ['FRAME_FILL', 'SHAPE_FILL'],
        value: '#303033',
    },
    'background/elevation-pressed': {
        alias: 'background/elevation-pressed',
        type: 'color',
        id: 'VariableID:10376:214954',
        desc: 'Pressed state for elevation. Independent value — literal in every mode, intentionally not aliased to surface.',
        scopes: ['FRAME_FILL', 'SHAPE_FILL'],
        value: '#1F1F22',
    },
    'background/highlight': {
        alias: 'background/highlight',
        type: 'color',
        id: 'VariableID:9564:13590',
        scopes: ['FRAME_FILL', 'SHAPE_FILL'],
        value: '#2D2D30',
    },
    'background/highlight-hover': {
        alias: 'background/highlight-hover',
        type: 'color',
        id: 'VariableID:9692:59685',
        desc: 'Hover state of highlight background — 8% white on highlight',
        scopes: ['FRAME_FILL', 'SHAPE_FILL'],
        value: '#37373A',
    },
    'background/highlight-pressed': {
        alias: 'background/highlight-pressed',
        type: 'color',
        id: 'VariableID:14063:59414',
        desc: 'Hover state of highlight background — 8% white on highlight',
        scopes: ['FRAME_FILL', 'SHAPE_FILL'],
        value: '#232326',
    },
    'background/input': {
        alias: 'background/input',
        type: 'color',
        id: 'VariableID:9924:54013',
        scopes: ['FRAME_FILL', 'SHAPE_FILL'],
        boundTo: 'background/canvas',
    },
    'background/input-hover': {
        alias: 'background/input-hover',
        type: 'color',
        id: 'VariableID:9924:54019',
        scopes: ['FRAME_FILL', 'SHAPE_FILL'],
        boundTo: 'background/canvas-hover',
    },
    'background/sub-surface': {
        alias: 'background/sub-surface',
        type: 'color',
        id: 'VariableID:6201:37712',
        desc: 'Structural sections — header, footer, sidebar',
        scopes: ['FRAME_FILL', 'SHAPE_FILL'],
        value: '#18181B',
    },
    'background/sub-surface-hover': {
        alias: 'background/sub-surface-hover',
        type: 'color',
        id: 'VariableID:9819:101347',
        desc: 'Structural sections — header, footer, sidebar',
        scopes: ['FRAME_FILL', 'SHAPE_FILL'],
        value: '#222129',
    },
    'background/sub-surface-pressed': {
        alias: 'background/sub-surface-pressed',
        type: 'color',
        id: 'VariableID:9936:24574',
        desc: 'Structural sections — header, footer, sidebar',
        scopes: ['FRAME_FILL', 'SHAPE_FILL'],
        value: '#111114',
    },
    'background/surface': {
        alias: 'background/surface',
        type: 'color',
        id: 'VariableID:6201:37713',
        desc: 'Main container body — card, modal, widget, list column',
        scopes: ['FRAME_FILL', 'SHAPE_FILL'],
        value: '#1F1F22',
    },
    'background/surface-hover': {
        alias: 'background/surface-hover',
        type: 'color',
        id: 'VariableID:6440:132966',
        desc: 'Overlay on hover — apply with explicit opacity 0.10–0.20',
        scopes: ['FRAME_FILL', 'SHAPE_FILL'],
        value: '#29292C',
    },
    'background/surface-pressed': {
        alias: 'background/surface-pressed',
        type: 'color',
        id: 'VariableID:10866:136437',
        desc: 'Main container body — card, modal, widget, list column',
        scopes: ['FRAME_FILL', 'SHAPE_FILL'],
        value: '#18181B',
    },
    'border/overlay': {
        alias: 'border/overlay',
        type: 'color',
        id: 'VariableID:19719:497105',
        modes: {
            'base-ui': {
                boundTo: 'silver/600',
                boundToCollection: '_Primitives graphics',
                value: '#AFB1B8',
            },
            'finavia': {
                boundTo: 'silver/600',
                boundToCollection: '_Primitives graphics',
                value: '#AFB1B8',
            },
            'swedavia': {
                value: '#FFFFFF',
            },
            'tallinn': {
                boundTo: 'silver/600',
                boundToCollection: '_Primitives graphics',
                value: '#AFB1B8',
            },
        },
    },
    'border/strong': {
        alias: 'border/strong',
        type: 'color',
        id: 'VariableID:6202:86640',
        desc: 'Emphasized borders, input focus alternative',
        scopes: ['STROKE_COLOR'],
        value: '#505051',
    },
    'border/subtle': {
        alias: 'border/subtle',
        type: 'color',
        id: 'VariableID:6201:37715',
        desc: 'Default container borders, separators — 1px inside',
        scopes: ['STROKE_COLOR'],
        value: '#2A2D32',
    },
    'border/transparent': {
        alias: 'border/transparent',
        type: 'color',
        id: 'VariableID:18232:384704',
        desc: "Invisible border that still occupies layout. Use it at rest wherever a state adds a border, so the state changes colour only and the component does not grow. Requires 'Include strokes in layout' on the frame.",
        scopes: ['STROKE_COLOR'],
        value: '#00000000',
    },
    'charts/apron-temperature': {
        alias: 'charts/apron-temperature',
        type: 'color',
        id: 'VariableID:15085:25413',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'lime/500',
        boundToCollection: '_Primitives graphics',
        value: '#95BD63',
    },
    'charts/dew-point': {
        alias: 'charts/dew-point',
        type: 'color',
        id: 'VariableID:15085:25412',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'orange/500',
        boundToCollection: '_Primitives graphics',
        value: '#EA9858',
    },
    'charts/level-1': {
        alias: 'charts/level-1',
        type: 'color',
        id: 'VariableID:15085:25403',
        desc: 'Ordered 4-level scale for weather charts. level-1 = lowest, level-4 = highest. When fewer levels are shown, use the top of the scale — e.g. with only 3 levels, use level-2, level-3 and level-4. The four hues sit on the same lightness step by design — the order is carried by the legend, not by the colour.',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'blue/500',
        boundToCollection: '_Primitives graphics',
        value: '#6FB2FC',
    },
    'charts/level-2': {
        alias: 'charts/level-2',
        type: 'color',
        id: 'VariableID:15085:25405',
        desc: 'Ordered 4-level scale for weather charts. level-1 = lowest, level-4 = highest. When fewer levels are shown, use the top of the scale — e.g. with only 3 levels, use level-2, level-3 and level-4. The four hues sit on the same lightness step by design — the order is carried by the legend, not by the colour.',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'teal/500',
        boundToCollection: '_Primitives graphics',
        value: '#08C6C8',
    },
    'charts/level-3': {
        alias: 'charts/level-3',
        type: 'color',
        id: 'VariableID:15085:25406',
        desc: 'Ordered 4-level scale for weather charts. level-1 = lowest, level-4 = highest. When fewer levels are shown, use the top of the scale — e.g. with only 3 levels, use level-2, level-3 and level-4. The four hues sit on the same lightness step by design — the order is carried by the legend, not by the colour.',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'violet/500',
        boundToCollection: '_Primitives graphics',
        value: '#B59CF5',
    },
    'charts/level-4': {
        alias: 'charts/level-4',
        type: 'color',
        id: 'VariableID:15085:25407',
        desc: 'Ordered 4-level scale for weather charts. level-1 = lowest, level-4 = highest. When fewer levels are shown, use the top of the scale — e.g. with only 3 levels, use level-2, level-3 and level-4. The four hues sit on the same lightness step by design — the order is carried by the legend, not by the colour.',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'pink/500',
        boundToCollection: '_Primitives graphics',
        value: '#E68CC2',
    },
    'charts/rain': {
        alias: 'charts/rain',
        type: 'color',
        id: 'VariableID:15085:25408',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'blue/500',
        boundToCollection: '_Primitives graphics',
        value: '#6FB2FC',
    },
    'charts/rain-snow': {
        alias: 'charts/rain-snow',
        type: 'color',
        id: 'VariableID:15085:25410',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'violet/500',
        boundToCollection: '_Primitives graphics',
        value: '#B59CF5',
    },
    'charts/snow': {
        alias: 'charts/snow',
        type: 'color',
        id: 'VariableID:15085:25409',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'teal/500',
        boundToCollection: '_Primitives graphics',
        value: '#08C6C8',
    },
    'charts/temperature': {
        alias: 'charts/temperature',
        type: 'color',
        id: 'VariableID:15085:25411',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'silver/500',
        boundToCollection: '_Primitives graphics',
        value: '#BBBDC4',
    },
    'charts/wind': {
        alias: 'charts/wind',
        type: 'color',
        id: 'VariableID:15085:25415',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'silver/500',
        boundToCollection: '_Primitives graphics',
        value: '#BBBDC4',
    },
    'content/default': {
        alias: 'content/default',
        type: 'color',
        id: 'VariableID:6201:37716',
        desc: 'Primary text and labels — light on dark',
        scopes: ['SHAPE_FILL', 'TEXT_FILL'],
        value: '#E5E5E6',
    },
    'content/destructive': {
        alias: 'content/destructive',
        type: 'color',
        id: 'VariableID:17807:517',
        desc: 'Destructive and error text/icons on dark surfaces — validation messages under inputs, the destructive menu label, critical counters. oklch(66.2% 0.226 31.6) = #FF4529. ΔL +6.75 from destructive/default in OKLCH (one and a half steps), C and H preserved; that delta reproduces this hex exactly. Clears WCAG AA 4.5:1 up to background/surface: 5.51:1 on canvas, 5.18:1 on sub-surface, 4.80:1 on surface, 4.66:1 on sub-surface-hover. Deliberately scoped to surface and darker — does NOT clear background/elevation (4.41:1) or surface-hover (4.24:1). Do NOT use on light surfaces (3.42:1 on aos-bg/white). destructive/default is a fill token: as text it reaches only 4.17:1 at best, which is why this token exists.',
        scopes: ['SHAPE_FILL', 'TEXT_FILL'],
        value: '#FF4529',
    },
    'content/inverted': {
        alias: 'content/inverted',
        type: 'color',
        id: 'VariableID:6205:37983',
        desc: 'Dark text on light surfaces',
        scopes: ['SHAPE_FILL', 'TEXT_FILL'],
        value: '#2B2B2B',
    },
    'content/knockout': {
        alias: 'content/knockout',
        type: 'color',
        id: 'VariableID:17784:517',
        desc: 'Pure white #FFFFFF for text and icons knocked out of any saturated fill — both status/critical* (flight and airport statuses: badges, timeline bars, flight tables) and destructive/* (the destructive Button, destructive modals). content/default (#E5E5E6) scores only 3.59:1 on status/critical, below WCAG AA 4.5:1 for body text; this scores 4.52:1 on status/critical and destructive/default, 4.93:1 on -hover and 5.42:1 on -pressed. Named for what it does rather than what it sits on, because it serves two different intents — an earlier content/on-critical was renamed here once the destructive family split off. Do NOT use on light surfaces.',
        scopes: ['SHAPE_FILL', 'TEXT_FILL'],
        value: '#FFFFFF',
    },
    'content/link': {
        alias: 'content/link',
        type: 'color',
        id: 'VariableID:10836:11048',
        scopes: ['SHAPE_FILL', 'TEXT_FILL'],
        boundTo: 'blue/400',
        boundToCollection: '_Primitives graphics',
        value: '#7BBCFF',
    },
    'content/link-hover': {
        alias: 'content/link-hover',
        type: 'color',
        id: 'VariableID:10836:11049',
        scopes: ['SHAPE_FILL', 'TEXT_FILL'],
        boundTo: 'blue/300',
        boundToCollection: '_Primitives graphics',
        value: '#A0D2FF',
    },
    'content/link-pressed': {
        alias: 'content/link-pressed',
        type: 'color',
        id: 'VariableID:10836:11050',
        scopes: ['SHAPE_FILL', 'TEXT_FILL'],
        boundTo: 'blue/500',
        boundToCollection: '_Primitives graphics',
        value: '#6FB2FC',
    },
    'content/link-visited': {
        alias: 'content/link-visited',
        type: 'color',
        id: 'VariableID:10836:11051',
        scopes: ['SHAPE_FILL', 'TEXT_FILL'],
        boundTo: 'violet/400',
        boundToCollection: '_Primitives graphics',
        value: '#BFA6FE',
    },
    'content/logotype': {
        alias: 'content/logotype',
        type: 'color',
        id: 'VariableID:6440:121209',
        desc: 'Pure white for non-text brand marks',
        scopes: ['SHAPE_FILL', 'TEXT_FILL'],
        value: '#FFFFFF',
    },
    'content/muted': {
        alias: 'content/muted',
        type: 'color',
        id: 'VariableID:6201:37717',
        desc: 'Secondary text, placeholders, captions',
        scopes: ['SHAPE_FILL', 'TEXT_FILL'],
        value: '#ACADAF',
    },
    'content/on-action': {
        alias: 'content/on-action',
        type: 'color',
        id: 'VariableID:9192:11984',
        desc: 'Text/icon on Action/default background (checkbox tick, toggle thumb). Aliases Content/on-primary by default.',
        scopes: ['SHAPE_FILL', 'TEXT_FILL'],
        boundTo: 'content/on-primary',
    },
    'content/on-primary': {
        alias: 'content/on-primary',
        type: 'color',
        id: 'VariableID:6309:51525',
        desc: 'Text on Primary/default background',
        scopes: ['SHAPE_FILL', 'TEXT_FILL'],
        modes: {
            'base-ui': {
                value: '#ECF1F8',
            },
            'finavia': {
                value: '#ECF1F8',
            },
            'swedavia': {
                value: '#2B2B2B',
            },
            'tallinn': {
                value: '#2B2B2B',
            },
        },
    },
    'destructive/border': {
        alias: 'destructive/border',
        type: 'color',
        id: 'VariableID:17840:520',
        desc: 'Stroke for the destructive/error state — the outline of a form field in error. Aliases content/destructive (#FF4529) so the field outline and the message beneath it are one colour and cannot drift. 4.80:1 on background/surface, far above the 3:1 WCAG 1.4.11 threshold for graphical objects; status/critical gave only 3.64:1 there. Lives in destructive/* rather than border/*, mirroring primary/border: border/* holds the neutral strokes, intent strokes belong to their intent namespace.',
        scopes: ['STROKE_COLOR'],
        boundTo: 'content/destructive',
    },
    'destructive/default': {
        alias: 'destructive/default',
        type: 'color',
        id: 'VariableID:17840:517',
        desc: 'Fill for destructive actions — the destructive Button, destructive confirmation modals. Aliases status/critical (#E72400) so the value stays shared, while the name keeps destructive intent out of status/*, which is reserved for flight and airport operational statuses. Pair with content/knockout (#FFFFFF, 4.52:1).',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'TEXT_FILL'],
        boundTo: 'status/critical',
    },
    'destructive/hover': {
        alias: 'destructive/hover',
        type: 'color',
        id: 'VariableID:17840:518',
        desc: 'Hover fill for destructive actions. Aliases status/critical-hover (#DC2100). content/knockout scores 4.93:1 on it. Darkens rather than lightens because the label is white — see status/critical-hover for the reasoning.',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'TEXT_FILL'],
        boundTo: 'status/critical-hover',
    },
    'destructive/pressed': {
        alias: 'destructive/pressed',
        type: 'color',
        id: 'VariableID:17840:519',
        desc: 'Pressed fill for destructive actions. Aliases status/critical-pressed (#D01F00). content/knockout scores 5.42:1 on it.',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'TEXT_FILL'],
        boundTo: 'status/critical-pressed',
    },
    'flights/arrivals': {
        alias: 'flights/arrivals',
        type: 'color',
        id: 'VariableID:15078:25328',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'orange/500',
        boundToCollection: '_Primitives graphics',
        value: '#EA9858',
    },
    'flights/arrivals-local': {
        alias: 'flights/arrivals-local',
        type: 'color',
        id: 'VariableID:15085:25416',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'orange/700',
        boundToCollection: '_Primitives graphics',
        value: '#AC672D',
    },
    'flights/arrivals-transfer': {
        alias: 'flights/arrivals-transfer',
        type: 'color',
        id: 'VariableID:15085:55538',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'orange/900',
        boundToCollection: '_Primitives graphics',
        value: '#351A03',
    },
    'flights/cancelled': {
        alias: 'flights/cancelled',
        type: 'color',
        id: 'VariableID:15078:25330',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'pink/700',
        boundToCollection: '_Primitives graphics',
        value: '#A95D8B',
    },
    'flights/delayed': {
        alias: 'flights/delayed',
        type: 'color',
        id: 'VariableID:15078:25331',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'violet/700',
        boundToCollection: '_Primitives graphics',
        value: '#816BB6',
    },
    'flights/departures': {
        alias: 'flights/departures',
        type: 'color',
        id: 'VariableID:15078:25329',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'indigo/500',
        boundToCollection: '_Primitives graphics',
        value: '#8DAAFF',
    },
    'flights/departures-local': {
        alias: 'flights/departures-local',
        type: 'color',
        id: 'VariableID:15085:55539',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'indigo/700',
        boundToCollection: '_Primitives graphics',
        value: '#5E76BE',
    },
    'flights/departures-transfer': {
        alias: 'flights/departures-transfer',
        type: 'color',
        id: 'VariableID:15085:55540',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'indigo/900',
        boundToCollection: '_Primitives graphics',
        value: '#17203C',
    },
    'flights/on-time': {
        alias: 'flights/on-time',
        type: 'color',
        id: 'VariableID:15085:25398',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'dark-grey/500',
        boundToCollection: '_Primitives graphics',
        value: '#606063',
    },
    'focus/ring': {
        alias: 'focus/ring',
        type: 'color',
        id: 'VariableID:9192:11983',
        desc: 'Keyboard focus outline (2-3px offset). Separate from Action for high-contrast mode support (e.g. yellow #FFDD00 like GOV.UK).',
        scopes: ['EFFECT_COLOR', 'STROKE_COLOR'],
        boundTo: 'action/default',
    },
    'graphics/blue': {
        alias: 'graphics/blue',
        type: 'color',
        id: 'VariableID:6224:86686',
        desc: 'Chart series — categorical data visualization.',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'blue/500',
        boundToCollection: '_Primitives graphics',
        value: '#6FB2FC',
    },
    'graphics/blue-hover': {
        alias: 'graphics/blue-hover',
        type: 'color',
        id: 'VariableID:9754:69899',
        desc: 'Hover state of Graphics/blue.',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'blue/400',
        boundToCollection: '_Primitives graphics',
        value: '#7BBCFF',
    },
    'graphics/blue-light': {
        alias: 'graphics/blue-light',
        type: 'color',
        id: 'VariableID:14031:83322',
        desc: 'Light step of Graphics/blue — represents the lowest values on an intensity scale. Not part of the general chart palette.',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'blue/900',
        boundToCollection: '_Primitives graphics',
        value: '#0B233B',
    },
    'graphics/blue-medium': {
        alias: 'graphics/blue-medium',
        type: 'color',
        id: 'VariableID:14031:83318',
        desc: 'Medium step of Graphics/blue — represents mid-range values on an intensity scale. Not part of the general chart palette.',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'blue/700',
        boundToCollection: '_Primitives graphics',
        value: '#437DBC',
    },
    'graphics/blue-pressed': {
        alias: 'graphics/blue-pressed',
        type: 'color',
        id: 'VariableID:9924:80752',
        desc: 'Pressed state of Graphics/blue.',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'blue/600',
        boundToCollection: '_Primitives graphics',
        value: '#63A5EE',
    },
    'graphics/dark-grey': {
        alias: 'graphics/dark-grey',
        type: 'color',
        id: 'VariableID:9825:140285',
        desc: 'Chart series — categorical data visualization.',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'dark-grey/500',
        boundToCollection: '_Primitives graphics',
        value: '#606063',
    },
    'graphics/dark-grey-hover': {
        alias: 'graphics/dark-grey-hover',
        type: 'color',
        id: 'VariableID:9825:140287',
        desc: 'Hover state of Graphics/dark-grey.',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'dark-grey/400',
        boundToCollection: '_Primitives graphics',
        value: '#6B6B6F',
    },
    'graphics/dark-grey-pressed': {
        alias: 'graphics/dark-grey-pressed',
        type: 'color',
        id: 'VariableID:10156:77716',
        desc: 'Pressed state of Graphics/dark-grey.',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'dark-grey/600',
        boundToCollection: '_Primitives graphics',
        value: '#555558',
    },
    'graphics/green': {
        alias: 'graphics/green',
        type: 'color',
        id: 'VariableID:6224:86687',
        desc: 'Chart series — categorical data visualization.',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'green/500',
        boundToCollection: '_Primitives graphics',
        value: '#79C379',
    },
    'graphics/green-hover': {
        alias: 'graphics/green-hover',
        type: 'color',
        id: 'VariableID:9754:69897',
        desc: 'Hover state of Graphics/green.',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'green/400',
        boundToCollection: '_Primitives graphics',
        value: '#84CC84',
    },
    'graphics/green-pressed': {
        alias: 'graphics/green-pressed',
        type: 'color',
        id: 'VariableID:9924:80751',
        desc: 'Pressed state of Graphics/green.',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'green/600',
        boundToCollection: '_Primitives graphics',
        value: '#6DB66D',
    },
    'graphics/grey': {
        alias: 'graphics/grey',
        type: 'color',
        id: 'VariableID:6237:88866',
        desc: 'Chart series — categorical data visualization.',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'grey/500',
        boundToCollection: '_Primitives graphics',
        value: '#8F8F92',
    },
    'graphics/grey-hover': {
        alias: 'graphics/grey-hover',
        type: 'color',
        id: 'VariableID:9754:69904',
        desc: 'Hover state of Graphics/grey.',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'grey/400',
        boundToCollection: '_Primitives graphics',
        value: '#9B9B9E',
    },
    'graphics/grey-pressed': {
        alias: 'graphics/grey-pressed',
        type: 'color',
        id: 'VariableID:10156:77714',
        desc: 'Pressed state of Graphics/grey.',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'grey/600',
        boundToCollection: '_Primitives graphics',
        value: '#838386',
    },
    'graphics/indigo': {
        alias: 'graphics/indigo',
        type: 'color',
        id: 'VariableID:6594:73835',
        desc: 'Chart series — categorical data visualization.',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'indigo/500',
        boundToCollection: '_Primitives graphics',
        value: '#8DAAFF',
    },
    'graphics/indigo-hover': {
        alias: 'graphics/indigo-hover',
        type: 'color',
        id: 'VariableID:9754:69900',
        desc: 'Hover state of Graphics/indigo.',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'indigo/400',
        boundToCollection: '_Primitives graphics',
        value: '#97B4FF',
    },
    'graphics/indigo-light': {
        alias: 'graphics/indigo-light',
        type: 'color',
        id: 'VariableID:14031:83330',
        desc: 'Light step of Graphics/indigo — represents the lowest values on an intensity scale. Not part of the general chart palette.',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'indigo/900',
        boundToCollection: '_Primitives graphics',
        value: '#17203C',
    },
    'graphics/indigo-medium': {
        alias: 'graphics/indigo-medium',
        type: 'color',
        id: 'VariableID:14031:83326',
        desc: 'Medium step of Graphics/indigo — represents mid-range values on an intensity scale. Not part of the general chart palette.',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'indigo/700',
        boundToCollection: '_Primitives graphics',
        value: '#5E76BE',
    },
    'graphics/indigo-pressed': {
        alias: 'graphics/indigo-pressed',
        type: 'color',
        id: 'VariableID:10156:77709',
        desc: 'Pressed state of Graphics/indigo.',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'indigo/600',
        boundToCollection: '_Primitives graphics',
        value: '#819DF1',
    },
    'graphics/lavender': {
        alias: 'graphics/lavender',
        type: 'color',
        id: 'VariableID:6224:86684',
        desc: 'Chart series — categorical data visualization.',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'lavender/500',
        boundToCollection: '_Primitives graphics',
        value: '#BF99EF',
    },
    'graphics/lavender-hover': {
        alias: 'graphics/lavender-hover',
        type: 'color',
        id: 'VariableID:9754:69902',
        desc: 'Hover state of Graphics/lavender.',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'lavender/400',
        boundToCollection: '_Primitives graphics',
        value: '#C8A3F8',
    },
    'graphics/lavender-pressed': {
        alias: 'graphics/lavender-pressed',
        type: 'color',
        id: 'VariableID:10156:77712',
        desc: 'Pressed state of Graphics/lavender.',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'lavender/600',
        boundToCollection: '_Primitives graphics',
        value: '#B38DE2',
    },
    'graphics/lime': {
        alias: 'graphics/lime',
        type: 'color',
        id: 'VariableID:6872:13632',
        desc: 'Chart series — categorical data visualization.',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'lime/500',
        boundToCollection: '_Primitives graphics',
        value: '#95BD63',
    },
    'graphics/lime-hover': {
        alias: 'graphics/lime-hover',
        type: 'color',
        id: 'VariableID:9754:69896',
        desc: 'Hover state of Graphics/lime.',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'lime/400',
        boundToCollection: '_Primitives graphics',
        value: '#9FC76E',
    },
    'graphics/lime-pressed': {
        alias: 'graphics/lime-pressed',
        type: 'color',
        id: 'VariableID:10156:77715',
        desc: 'Pressed state of Graphics/lime.',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'lime/600',
        boundToCollection: '_Primitives graphics',
        value: '#89B156',
    },
    'graphics/orange': {
        alias: 'graphics/orange',
        type: 'color',
        id: 'VariableID:6224:86682',
        desc: 'Chart series — categorical data visualization.',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'orange/500',
        boundToCollection: '_Primitives graphics',
        value: '#EA9858',
    },
    'graphics/orange-hover': {
        alias: 'graphics/orange-hover',
        type: 'color',
        id: 'VariableID:9754:69894',
        desc: 'Hover state of Graphics/orange.',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'orange/400',
        boundToCollection: '_Primitives graphics',
        value: '#F3A264',
    },
    'graphics/orange-light': {
        alias: 'graphics/orange-light',
        type: 'color',
        id: 'VariableID:10836:48469',
        desc: 'Light step of Graphics/orange — represents the lowest values on an intensity scale. Not part of the general chart palette.',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'orange/900',
        boundToCollection: '_Primitives graphics',
        value: '#351A03',
    },
    'graphics/orange-medium': {
        alias: 'graphics/orange-medium',
        type: 'color',
        id: 'VariableID:10836:48468',
        desc: 'Medium step of Graphics/orange — represents mid-range values on an intensity scale. Not part of the general chart palette.',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'orange/700',
        boundToCollection: '_Primitives graphics',
        value: '#AC672D',
    },
    'graphics/orange-pressed': {
        alias: 'graphics/orange-pressed',
        type: 'color',
        id: 'VariableID:10156:77713',
        desc: 'Pressed state of Graphics/orange.',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'orange/600',
        boundToCollection: '_Primitives graphics',
        value: '#DC8C4B',
    },
    'graphics/pink': {
        alias: 'graphics/pink',
        type: 'color',
        id: 'VariableID:6224:86688',
        desc: 'Chart series — categorical data visualization.',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'pink/500',
        boundToCollection: '_Primitives graphics',
        value: '#E68CC2',
    },
    'graphics/pink-hover': {
        alias: 'graphics/pink-hover',
        type: 'color',
        id: 'VariableID:9754:69903',
        desc: 'Hover state of Graphics/pink.',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'pink/400',
        boundToCollection: '_Primitives graphics',
        value: '#EF96CB',
    },
    'graphics/pink-light': {
        alias: 'graphics/pink-light',
        type: 'color',
        id: 'VariableID:10836:48475',
        desc: 'Light step of Graphics/pink — represents the lowest values on an intensity scale. Not part of the general chart palette.',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'pink/900',
        boundToCollection: '_Primitives graphics',
        value: '#331628',
    },
    'graphics/pink-medium': {
        alias: 'graphics/pink-medium',
        type: 'color',
        id: 'VariableID:10836:48474',
        desc: 'Medium step of Graphics/pink — represents mid-range values on an intensity scale. Not part of the general chart palette.',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'pink/700',
        boundToCollection: '_Primitives graphics',
        value: '#A95D8B',
    },
    'graphics/pink-pressed': {
        alias: 'graphics/pink-pressed',
        type: 'color',
        id: 'VariableID:10156:77711',
        desc: 'Pressed state of Graphics/pink.',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'pink/600',
        boundToCollection: '_Primitives graphics',
        value: '#D880B5',
    },
    'graphics/red': {
        alias: 'graphics/red',
        type: 'color',
        id: 'VariableID:6594:73834',
        desc: 'Chart series — categorical data visualization.',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'red/500',
        boundToCollection: '_Primitives graphics',
        value: '#F48D80',
    },
    'graphics/red-hover': {
        alias: 'graphics/red-hover',
        type: 'color',
        id: 'VariableID:9754:69893',
        desc: 'Hover state of Graphics/red.',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'red/400',
        boundToCollection: '_Primitives graphics',
        value: '#FD978A',
    },
    'graphics/red-pressed': {
        alias: 'graphics/red-pressed',
        type: 'color',
        id: 'VariableID:9924:80733',
        desc: 'Pressed state of Graphics/red.',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'red/600',
        boundToCollection: '_Primitives graphics',
        value: '#E68174',
    },
    'graphics/silver': {
        alias: 'graphics/silver',
        type: 'color',
        id: 'VariableID:6224:86680',
        desc: 'Chart series — categorical data visualization.',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'silver/500',
        boundToCollection: '_Primitives graphics',
        value: '#BBBDC4',
    },
    'graphics/silver-hover': {
        alias: 'graphics/silver-hover',
        type: 'color',
        id: 'VariableID:9754:69905',
        desc: 'Hover state of Graphics/silver.',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'silver/400',
        boundToCollection: '_Primitives graphics',
        value: '#C8CAD1',
    },
    'graphics/silver-light': {
        alias: 'graphics/silver-light',
        type: 'color',
        id: 'VariableID:10836:48471',
        desc: 'Light step of Graphics/silver — represents the lowest values on an intensity scale. Not part of the general chart palette.',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'silver/900',
        boundToCollection: '_Primitives graphics',
        value: '#2C2E33',
    },
    'graphics/silver-medium': {
        alias: 'graphics/silver-medium',
        type: 'color',
        id: 'VariableID:10836:48470',
        desc: 'Medium step of Graphics/silver — represents mid-range values on an intensity scale. Not part of the general chart palette.',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'silver/700',
        boundToCollection: '_Primitives graphics',
        value: '#8D8F95',
    },
    'graphics/silver-pressed': {
        alias: 'graphics/silver-pressed',
        type: 'color',
        id: 'VariableID:9924:80750',
        desc: 'Pressed state of Graphics/silver.',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'silver/600',
        boundToCollection: '_Primitives graphics',
        value: '#AFB1B8',
    },
    'graphics/teal': {
        alias: 'graphics/teal',
        type: 'color',
        id: 'VariableID:6285:45913',
        desc: 'Chart series — categorical data visualization.',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'teal/500',
        boundToCollection: '_Primitives graphics',
        value: '#08C6C8',
    },
    'graphics/teal-hover': {
        alias: 'graphics/teal-hover',
        type: 'color',
        id: 'VariableID:9754:69898',
        desc: 'Hover state of Graphics/teal.',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'teal/400',
        boundToCollection: '_Primitives graphics',
        value: '#30CFD1',
    },
    'graphics/teal-light': {
        alias: 'graphics/teal-light',
        type: 'color',
        id: 'VariableID:10836:48473',
        desc: 'Light step of Graphics/teal — represents the lowest values on an intensity scale. Not part of the general chart palette.',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'teal/900',
        boundToCollection: '_Primitives graphics',
        value: '#00292A',
    },
    'graphics/teal-medium': {
        alias: 'graphics/teal-medium',
        type: 'color',
        id: 'VariableID:10836:48472',
        desc: 'Medium step of Graphics/teal — represents mid-range values on an intensity scale. Not part of the general chart palette.',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'teal/700',
        boundToCollection: '_Primitives graphics',
        value: '#008E91',
    },
    'graphics/teal-pressed': {
        alias: 'graphics/teal-pressed',
        type: 'color',
        id: 'VariableID:10156:77710',
        desc: 'Pressed state of Graphics/teal.',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'teal/600',
        boundToCollection: '_Primitives graphics',
        value: '#00B9BB',
    },
    'graphics/violet': {
        alias: 'graphics/violet',
        type: 'color',
        id: 'VariableID:6594:73836',
        desc: 'Chart series — categorical data visualization.',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'violet/500',
        boundToCollection: '_Primitives graphics',
        value: '#B59CF5',
    },
    'graphics/violet-hover': {
        alias: 'graphics/violet-hover',
        type: 'color',
        id: 'VariableID:9754:69901',
        desc: 'Hover state of Graphics/violet.',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'violet/400',
        boundToCollection: '_Primitives graphics',
        value: '#BFA6FE',
    },
    'graphics/violet-light': {
        alias: 'graphics/violet-light',
        type: 'color',
        id: 'VariableID:10836:48989',
        desc: 'Light step of Graphics/violet — represents the lowest values on an intensity scale. Not part of the general chart palette.',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'violet/900',
        boundToCollection: '_Primitives graphics',
        value: '#241B39',
    },
    'graphics/violet-medium': {
        alias: 'graphics/violet-medium',
        type: 'color',
        id: 'VariableID:10836:48988',
        desc: 'Medium step of Graphics/violet — represents mid-range values on an intensity scale. Not part of the general chart palette.',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'violet/700',
        boundToCollection: '_Primitives graphics',
        value: '#816BB6',
    },
    'graphics/violet-pressed': {
        alias: 'graphics/violet-pressed',
        type: 'color',
        id: 'VariableID:10156:77708',
        desc: 'Pressed state of Graphics/violet.',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'violet/600',
        boundToCollection: '_Primitives graphics',
        value: '#A990E7',
    },
    'graphics/yellow': {
        alias: 'graphics/yellow',
        type: 'color',
        id: 'VariableID:6224:86681',
        desc: 'Chart series — categorical data visualization.',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'yellow/500',
        boundToCollection: '_Primitives graphics',
        value: '#D3A742',
    },
    'graphics/yellow-hover': {
        alias: 'graphics/yellow-hover',
        type: 'color',
        id: 'VariableID:9754:69895',
        desc: 'Hover state of Graphics/yellow.',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'yellow/400',
        boundToCollection: '_Primitives graphics',
        value: '#DCB151',
    },
    'graphics/yellow-pressed': {
        alias: 'graphics/yellow-pressed',
        type: 'color',
        id: 'VariableID:10156:77707',
        desc: 'Pressed state of Graphics/yellow.',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'yellow/600',
        boundToCollection: '_Primitives graphics',
        value: '#C69A33',
    },
    'primary/border': {
        alias: 'primary/border',
        type: 'color',
        id: 'VariableID:9340:136118',
        desc: 'Brand-tinted container border — pairs with Primary/surface',
        scopes: ['STROKE_COLOR'],
        modes: {
            'base-ui': {
                value: '#405088',
            },
            'finavia': {
                boundTo: '_finavia/border',
                boundToCollection: '_BrandColors',
                value: '#3254A7',
            },
            'swedavia': {
                boundTo: '_swedavia/border',
                boundToCollection: '_BrandColors',
                value: '#008ACB',
            },
            'tallinn': {
                boundTo: '_tallinn/border',
                boundToCollection: '_BrandColors',
                value: '#615823',
            },
        },
    },
    'primary/default': {
        alias: 'primary/default',
        type: 'color',
        id: 'VariableID:6201:37718',
        desc: 'Button fill, large CTA, header underline',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'TEXT_FILL'],
        modes: {
            'base-ui': {
                value: '#3459C6',
            },
            'finavia': {
                boundTo: '_finavia/default',
                boundToCollection: '_BrandColors',
                value: '#005DE5',
            },
            'swedavia': {
                boundTo: '_swedavia/default',
                boundToCollection: '_BrandColors',
                value: '#3192D0',
            },
            'tallinn': {
                boundTo: '_tallinn/default',
                boundToCollection: '_BrandColors',
                value: '#FFDD4F',
            },
        },
    },
    'primary/hover': {
        alias: 'primary/hover',
        type: 'color',
        id: 'VariableID:6240:88879',
        desc: 'Hover state of primary-colored elements',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'TEXT_FILL'],
        modes: {
            'base-ui': {
                value: '#3D66DA',
            },
            'finavia': {
                boundTo: '_finavia/hover',
                boundToCollection: '_BrandColors',
                value: '#0C6BFA',
            },
            'swedavia': {
                boundTo: '_swedavia/hover',
                boundToCollection: '_BrandColors',
                value: '#26AAED',
            },
            'tallinn': {
                boundTo: '_tallinn/hover',
                boundToCollection: '_BrandColors',
                value: '#FFEC61',
            },
        },
    },
    'primary/pressed': {
        alias: 'primary/pressed',
        type: 'color',
        id: 'VariableID:6240:88880',
        desc: 'Pressed / active state of primary-colored elements',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'TEXT_FILL'],
        modes: {
            'base-ui': {
                value: '#2B4DB1',
            },
            'finavia': {
                boundTo: '_finavia/pressed',
                boundToCollection: '_BrandColors',
                value: '#0050CF',
            },
            'swedavia': {
                boundTo: '_swedavia/pressed',
                boundToCollection: '_BrandColors',
                value: '#008ECF',
            },
            'tallinn': {
                boundTo: '_tallinn/pressed',
                boundToCollection: '_BrandColors',
                value: '#F0CE3C',
            },
        },
    },
    'primary/surface': {
        alias: 'primary/surface',
        type: 'color',
        id: 'VariableID:9340:136117',
        desc: 'Brand-tinted container background — messages, comments, callouts, featured content areas',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'TEXT_FILL'],
        modes: {
            'base-ui': {
                value: '#24315E',
            },
            'finavia': {
                boundTo: '_finavia/surface',
                boundToCollection: '_BrandColors',
                value: '#16347A',
            },
            'swedavia': {
                boundTo: '_swedavia/surface',
                boundToCollection: '_BrandColors',
                value: '#1F3D50',
            },
            'tallinn': {
                boundTo: '_tallinn/surface',
                boundToCollection: '_BrandColors',
                value: '#272417',
            },
        },
    },
    'status/caution': {
        alias: 'status/caution',
        type: 'color',
        id: 'VariableID:6987:127103',
        desc: 'Mild warning, proceed with care. oklch(75.0% 0.175 55.8). Use content/inverted for text and icons on this fill (6.04:1).',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR', 'TEXT_FILL'],
        value: '#FF8B1F',
    },
    'status/caution-hover': {
        alias: 'status/caution-hover',
        type: 'color',
        id: 'VariableID:6987:127340',
        desc: 'Hover state for caution status. oklch(79.0% 0.155 63.3). Off-rule: ΔL +4.02 (rule +4.5), ΔH +7.4°, ΔC −0.020 — value predates the OKLCH rule and was not recomputed. On-rule value would be #FFA35E.',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR', 'TEXT_FILL'],
        value: '#FFA23F',
    },
    'status/caution-pressed': {
        alias: 'status/caution-pressed',
        type: 'color',
        id: 'VariableID:10376:214948',
        desc: 'Pressed state for caution status. oklch(70.5% 0.174 55.5). ΔL −4.5 from status/caution in OKLCH, C and H preserved (chroma clipped to sRGB).',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR', 'TEXT_FILL'],
        value: '#EF7D00',
    },
    'status/critical': {
        alias: 'status/critical',
        type: 'color',
        id: 'VariableID:6987:127102',
        desc: 'Alarm, cancellation, destructive action. oklch(59.4% 0.228 31.5). Use content/knockout for text and icons on this fill (4.52:1).',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR', 'TEXT_FILL'],
        value: '#E72400',
    },
    'status/critical-hover': {
        alias: 'status/critical-hover',
        type: 'color',
        id: 'VariableID:6987:127339',
        desc: 'Hover state for critical status. oklch(57.2% 0.221 31.4). ΔL −2.25 from status/critical in OKLCH (half step), C and H preserved. Darkens instead of lightening because critical is the only status whose text is light (content/on-critical) — a lighter hover would drop text contrast below AA. Direction follows the text colour, not the family.',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR', 'TEXT_FILL'],
        value: '#DC2100',
    },
    'status/critical-pressed': {
        alias: 'status/critical-pressed',
        type: 'color',
        id: 'VariableID:9936:24573',
        desc: 'Pressed state for critical status. oklch(54.9% 0.211 31.4). ΔL −4.5 from status/critical in OKLCH, C and H preserved (chroma clipped to sRGB).',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR', 'TEXT_FILL'],
        value: '#D01F00',
    },
    'status/info': {
        alias: 'status/info',
        type: 'color',
        id: 'VariableID:7692:178738',
        desc: 'Informational, neutral highlight. oklch(69.6% 0.159 260.9). Use content/inverted for text and icons on this fill (5.16:1).',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR', 'TEXT_FILL'],
        value: '#629BFF',
    },
    'status/info-hover': {
        alias: 'status/info-hover',
        type: 'color',
        id: 'VariableID:7692:178739',
        desc: 'Hover state for info status. oklch(72.9% 0.141 258.3). Off-rule: ΔL +3.29 (rule +4.5), ΔH −2.6°, ΔC −0.018 — value predates the OKLCH rule and was not recomputed. On-rule value would be #7AABFF.',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR', 'TEXT_FILL'],
        value: '#6EA8FF',
    },
    'status/info-pressed': {
        alias: 'status/info-pressed',
        type: 'color',
        id: 'VariableID:10376:214951',
        desc: 'Pressed state for info status. oklch(65.2% 0.158 260.8). ΔL −4.5 from status/info in OKLCH, C and H preserved (chroma clipped to sRGB).',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR', 'TEXT_FILL'],
        value: '#558DEF',
    },
    'status/neutral': {
        alias: 'status/neutral',
        type: 'color',
        id: 'VariableID:6987:127106',
        desc: 'No status, inactive, N/A. oklch(69.2% 0.039 252.2). Use content/inverted for text and icons on this fill (5.16:1).',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR', 'TEXT_FILL'],
        value: '#9DB0C7',
    },
    'status/neutral-hover': {
        alias: 'status/neutral-hover',
        type: 'color',
        id: 'VariableID:6987:127343',
        desc: 'Hover state for neutral status. oklch(73.1% 0.040 253.3). Off-rule: ΔL +3.91 (rule +4.5), ΔH +1.1°, ΔC +0.001 — value predates the OKLCH rule and was not recomputed. On-rule value would be #99ACC2.',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR', 'TEXT_FILL'],
        value: '#ABBED5',
    },
    'status/neutral-pressed': {
        alias: 'status/neutral-pressed',
        type: 'color',
        id: 'VariableID:10376:214952',
        desc: 'Pressed state for neutral status. oklch(64.7% 0.039 253.6). ΔL −4.5 from status/neutral in OKLCH, C and H preserved (chroma clipped to sRGB).',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR', 'TEXT_FILL'],
        value: '#8FA2B8',
    },
    'status/success': {
        alias: 'status/success',
        type: 'color',
        id: 'VariableID:6987:127105',
        desc: 'On-time, confirmed, completed. oklch(75.0% 0.202 141.9). Use content/inverted for text and icons on this fill (6.82:1).',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR', 'TEXT_FILL'],
        value: '#54CC49',
    },
    'status/success-hover': {
        alias: 'status/success-hover',
        type: 'color',
        id: 'VariableID:6987:127342',
        desc: 'Hover state for success status. oklch(79.8% 0.203 141.9). Off-rule: ΔL +4.77 (rule +4.5), ΔH −0.1°, ΔC +0.002 — value predates the OKLCH rule and was not recomputed. On-rule value would be #64DB58.',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR', 'TEXT_FILL'],
        value: '#64DC58',
    },
    'status/success-pressed': {
        alias: 'status/success-pressed',
        type: 'color',
        id: 'VariableID:10376:214950',
        desc: 'Pressed state for success status. oklch(70.4% 0.202 141.8). ΔL −4.5 from status/success in OKLCH, C and H preserved (chroma clipped to sRGB).',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR', 'TEXT_FILL'],
        value: '#44BD38',
    },
    'status/warning': {
        alias: 'status/warning',
        type: 'color',
        id: 'VariableID:6987:127104',
        desc: 'Delay, attention needed. oklch(87.5% 0.175 96.2). Use content/inverted for text and icons on this fill (9.73:1).',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR', 'TEXT_FILL'],
        value: '#F8D41D',
    },
    'status/warning-hover': {
        alias: 'status/warning-hover',
        type: 'color',
        id: 'VariableID:6987:127341',
        desc: 'Hover state for warning status. oklch(92.0% 0.166 99.7). Off-rule: ΔL +4.49 matches the rule but ΔH +3.5° and ΔC −0.009 do not — C and H should be preserved. Value predates the OKLCH rule. On-rule value would be #FFE474.',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR', 'TEXT_FILL'],
        modes: {
            'base-ui': {
                value: '#FFE64E',
            },
            'finavia': {
                value: '#FFE474',
            },
            'swedavia': {
                value: '#FFE64E',
            },
            'tallinn': {
                value: '#FFE339',
            },
        },
    },
    'status/warning-pressed': {
        alias: 'status/warning-pressed',
        type: 'color',
        id: 'VariableID:10376:214949',
        desc: 'Pressed state for warning status. oklch(83.0% 0.171 95.7). ΔL −4.5 from status/warning in OKLCH, C and H preserved (chroma clipped to sRGB).',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR', 'TEXT_FILL'],
        value: '#E9C500',
    },
    'strings/client': {
        alias: 'strings/client',
        type: 'string',
        id: 'VariableID:10036:36278',
        scopes: ['TEXT_CONTENT'],
        modes: {
            'base-ui': {
                value: 'Finavia',
            },
            'finavia': {
                value: 'Finavia',
            },
            'swedavia': {
                value: 'Swedavia',
            },
            'tallinn': {
                value: 'Tallinn',
            },
        },
    },
    'waiting-time/border-arrivals': {
        alias: 'waiting-time/border-arrivals',
        type: 'color',
        id: 'VariableID:15085:25402',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'violet/500',
        boundToCollection: '_Primitives graphics',
        value: '#B59CF5',
    },
    'waiting-time/border-departures': {
        alias: 'waiting-time/border-departures',
        type: 'color',
        id: 'VariableID:15085:25401',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'red/500',
        boundToCollection: '_Primitives graphics',
        value: '#F48D80',
    },
    'waiting-time/security-departures': {
        alias: 'waiting-time/security-departures',
        type: 'color',
        id: 'VariableID:15085:25399',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'blue/500',
        boundToCollection: '_Primitives graphics',
        value: '#6FB2FC',
    },
    'waiting-time/security-transfer': {
        alias: 'waiting-time/security-transfer',
        type: 'color',
        id: 'VariableID:15085:25400',
        scopes: ['FRAME_FILL', 'SHAPE_FILL', 'STROKE_COLOR'],
        boundTo: 'teal/500',
        boundToCollection: '_Primitives graphics',
        value: '#08C6C8',
    },
} as const
